<template>
  <billing-report-panel
    report-key="glosses-professional"
    route="/reports/billing-glosses-professional"
    file-name="glosas-por-profissional.xlsx"
    :columns="columns"
    show-professional
  />
</template>

<script>
import BillingReportPanel from './BillingReportPanel.vue';

export default {
  components: {
    BillingReportPanel,
  },
  data() {
    return {
      columns: [
        'Profissional executante',
        'Glosas',
        'Guias',
        'Glosado',
        'Recursado',
        'Recuperado',
        'Perda',
        'Efeito no repasse',
        'Acerto a descontar',
        'Acerto a devolver',
      ],
    };
  },
};
</script>
